<template>
  <div class="header">
    <el-header>
      <div class="title">航越后台</div>
      <el-dropdown @command="logout" class="logout">
        <span class="el-dropdown-link">
          {{name == undefined ? '账号过期' : '您好,' + name }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-header>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name:'',
    };
  },
  created () {
    this.name = window.localStorage.getItem('un');
  },
  methods: {
    logout() {
      this.$router.push({ path: "/" });
    }
  },
};
</script>

<style lang="scss" scoped>
.header {
  .el-header {
    background: #409eff;
    color: #fff;
    line-height: 60px;
    display: flex;
    justify-content: space-between;
    .title {
      width: 100px;
      font-size: 16px;
    }
    .logout {
      width: 100px;
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>
